import axios, { AxiosError } from 'axios';

interface ErrorResponse {
    title?: string;
    detail?: string;
    errors?: Record<string, string>;
}

export class ErrorUtils {
    static extractErrorDetails(
        error: Error | AxiosError | null
    ): ExtractedErrorDetails {
        if (!this.isValidAxiosError(error)) {
            return this.createEmptyErrorDetails();
        }

        const resData = error.response?.data as ErrorResponse | undefined;
        return {
            title: resData?.title ?? null,
            detail: this.buildDetailMessage(resData),
            responseCode: error.response?.status ?? null
        };
    }

    private static isValidAxiosError(
        error: Error | AxiosError | null
    ): error is AxiosError {
        return (
            error !== null && error !== undefined && axios.isAxiosError(error)
        );
    }

    private static createEmptyErrorDetails(): ExtractedErrorDetails {
        return { title: null, detail: null, responseCode: null };
    }

    private static buildDetailMessage(resData?: ErrorResponse): string | null {
        const messages: string[] = [];

        if (resData?.detail) {
            messages.push(resData.detail);
        }

        if (resData?.errors) {
            messages.push(Object.values(resData.errors).join('\n'));
        }

        return messages.length > 0 ? messages.join('\n') : null;
    }
}

export interface ExtractedErrorDetails {
    title: string | null;
    detail: string | null;
    responseCode: number | null;
}
